import Select from '__components/Inputs/Select';
import { getDataQAForInput } from 'components/Inputs/helpers';
import { useErrors } from 'pages/SmartConnectors/SmartConnector/hooks/useErrors';
import { FC, useContext, useMemo } from 'react';
import { SmartConnectorContext } from '../../context';

export const CadenceSelect: FC<{
  value: number | undefined;
  onChange: (value: number) => void;
  label: string;
  labelInfo?: string;
}> = ({ value, label, labelInfo, onChange }) => {
  const { metaData } = useContext(SmartConnectorContext);

  const { clearError, validate, error } = useErrors('cadence');

  const options = useMemo(() => {
    return metaData?.cadence_choices.map(([value, label]) => ({
      label,
      value,
    }));
  }, [metaData]);

  const handleChange = ({ value }: { value: string }) => {
    onChange(parseInt(value));
    clearError();
  };

  return (
    <Select
      label={label}
      labelInfo={labelInfo}
      labelInfoPlacement="top"
      value={String(value)}
      onChange={handleChange}
      options={options}
      margin
      error={error}
      validate={validate}
      {...getDataQAForInput('smart-connector-webhook-cadence', 'dropdown')}
    />
  );
};
